import React, { Component } from 'react';
import dates from './utils/dates';
import TimeGrid from './TimeGrid';
import { navigate } from './utils/constants';

class Day extends Component {

  static propTypes = TimeGrid.propTypes;
  static defaultProps = TimeGrid.defaultProps;

  render() {
    const { date } = this.props;
    const { start, end } = Day.range(date);

    return (
      <TimeGrid {...this.props} start={start} end={end} eventOffset={10} />
    );
  }
}

Day.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'day');

    case navigate.NEXT:
      return dates.add(date, 1, 'day');

    default:
      return date;
  }
};

Day.range = (_date) => {
  const start = dates.startOf(_date, 'day');
  const end = dates.endOf(start, 'day');
  return { start, end };
};

export default Day;
